import React from 'react';
import { Controller } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CheckboxErrorTypography } from 'components/Ui/styled';

export const FormInputCheckbox = ({
  name,
  label,
  errors,
  control,
  disabled = false,
  readOnly = false,
  onValueChange,
}) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            sx={{
              display: 'flex',
              alignItems: 'start',
              placeItems: 'anchor-center',
              '& .MuiFormControlLabel-label': {
                fontWeight: 410,
                fontSize: '0.95rem',
              },
            }}
            control={
              <Checkbox
                {...field}
                disabled={disabled}
                readOnly={readOnly}
                checked={!!field.value}
                onChange={(e) => {
                  if (!readOnly && !disabled) {
                    const checked = e?.target?.checked;

                    field.onChange(checked);
                    if (onValueChange) {
                      onValueChange(checked);
                    }
                  }
                }}
              />
            }
            label={label}
          />
        )}
      />
      {errors?.[name] && (
        <CheckboxErrorTypography color="error" variant="caption">
          {errors[name].message}
        </CheckboxErrorTypography>
      )}
    </>
  );
};
